import { ScrollTop } from '@/components/element/ScrollTop';
import { SalesOrderContractTaskFileEditForm } from '@/components/features/tasks/sales_order_contract/[sales_order_contract_task_id]/SalesOrderContractTaskFileEditForm';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentSalesOrderContractTask } from '@/providers/SalesOrderContractTaskProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export const BackofficeSalesOrderContractTaskFiles = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { setTitle, setBreadcrumbs } = useNavState();
  const { sales_order_id } = useParams();
  const { salesOrderContractTask: task } = useCurrentSalesOrderContractTask();
  useEffect(() => setTitle('契約書等ファイル一覧'), []);
  useEffect(
    () =>
      setBreadcrumbs([
        {
          label: `契約申請（売上）タスク一覧`,
          path: `/w/${_w_!.identifier}/backoffice/sales_order_contract_tasks`,
        },
        {
          label: `契約申請（売上）タスク詳細`,
          path: `/w/${_w_!.identifier}/backoffice/teams/${
            _t_!.id
          }/sales_orders/${sales_order_id}/sales_order_contract_tasks/${task!.id}`,
        },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <SalesOrderContractTaskFileEditForm />
    </WorkspaceLayout>
  );
};
